import React from "react";
import { connect } from "react-redux";

import buildData from "../buildData/buildData";
import config from "../config/legalworks.frontend.config";

import InfoRow from "./InfoRow";

function DevInfo({ cognitoSub, username }) {
	return (
		<div style={{ padding: "0 24px" }}>
			<h3 style={{ marginTop: 32, marginBottom: 12, fontSize: 16 }}>
				User Info
			</h3>
			{cognitoSub ? (
				<>
					<InfoRow label="Username" value={username} />
					<InfoRow label="Cognito Sub" value={cognitoSub} />
				</>
			) : (
				<span>No Authenticated User</span>
			)}

			<h3
				style={{
					marginTop: 32,
					marginBottom: 12,
					fontSize: 16,
					fontFamily: "monospace",
				}}
			>
				buildData.json
			</h3>
			<InfoRow label="Build Number" value={buildData.buildNumber} />
			<InfoRow
				label="Build Time Central"
				value={buildData.buildTimeCentral}
			/>
			<InfoRow label="Branch" value={buildData.branch} />
			<InfoRow label="Commit Hash" value={buildData.lastCommit} />
			<InfoRow label="Build Time UTC" value={buildData.buildTimeUTC} />
			<InfoRow
				label="Runtime Environment"
				value={buildData.runtimeEnvironment}
			/>
			<InfoRow
				label="Build Environment"
				value={buildData.buildEnvironment}
			/>

			<h3
				style={{
					marginTop: 32,
					marginBottom: 12,
					fontSize: 16,
					fontFamily: "monospace",
				}}
			>
				frontend.config.json
			</h3>
			<InfoRow label="Variant Name" value={config.variantName} />
			<InfoRow label="API Name" value={config.apiName} />
			<InfoRow label="Domain" value={config.domain} />

			<h3 style={{ marginTop: 32, marginBottom: 12, fontSize: 16 }}>
				Environment Variables
			</h3>
			<InfoRow
				label="VITE_ENVIRONMENT"
				value={import.meta.env.VITE_ENVIRONMENT}
			/>
			<InfoRow
				label="VITE_RUNNING_IN"
				value={import.meta.env.VITE_RUNNING_IN}
			/>
		</div>
	);
}

const mapStateToProps = (state) => ({
	cognitoSub: state?.user?.cognitoUser?.attributes?.sub,
	username: state?.user?.username,
});

export default connect(mapStateToProps, {})(DevInfo);
